import "./spinner.css";

const Spinner = ({ size }) => {
  const spinnerStyle = {
    width: size || "50px",
    height: size || "50px",
  };

  return (
    <div>
      <div id="loading" style={spinnerStyle}></div>
    </div>
  );
};

export default Spinner;
